'use client';

import { useEffect } from 'react';

export default function OsanoUi() {
  useEffect(() => {
    const renderUi = () => window.Osano?.cm?.render();

    if (window.Osano?.cm) {
      renderUi();
    } else {
      window.Osano?.('onInitialized', renderUi);
    }
  }, []);

  return null;
}
